import { Collection } from 'modules/core/lib/mobx-rest'

import TaxResidence from 'modules/payroll_bundle/store/models/TaxResidence'

class TaxResidences extends Collection<TaxResidence> {
  get cacheKey(): string {
    return 'taxResidences'
  }

  model() {
    return TaxResidence
  }
}

const singleton = new TaxResidences()

export default singleton
